import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class WarehouseLocationService extends ApiService {
  namespace = "warehouse-location";
  icon = "PalletizedBoxes";
  name = "Warehouse Location";
  favicon = "BoxWithLabel";
  window = 290;
  Width = 900;
  DOMAIN = -47;
  action = "action";
  singular = this.terminology.warehouseLocation.singular;
  plural = this.terminology.warehouseLocation.plural;
  vowel = this.terminology.warehouseLocation.vowel;
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: "Bookmark",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      icon: "Disable",
    },
  ];

  columns = [
    {
      header: this.t("displayName"),
      icon: "Tag",
      field: "display_name",
    },
    {
      header: this.t("Asset"),
      icon: "Tag",
      field: "asset",
      template: (data) => {
        return data.warehouse;
      },
    },
    {
      header: this.t("Created By"),
      icon: "UserSilhouette",
      field: "created_by",
    },
    {
      header: this.t("Created"),
      icon: "Calendar",
      field: "created_at",
      template: (data) => {
        return new Date(data.created_at * 1000).toLocaleDateString("en-US");
      },
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Open this Warehouse Loc...",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: PrimeIcons.LOCK,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Type",
      icon: PrimeIcons.LIST,
    },
  ];
  constructor() {
    super("warehouse-locations");
  }
}
